import CmsSelect2 from "../../../../assets/js/modules/cms-select2";
import UserCodeInput from "../../../../assets/js/modules/cms-user-code";
import ApplicationsReceiverCard from "./ApplicationsReceiverCard";

class ApplicationsWizard {
    constructor(props, context) {
        let defaults = {
            version: '1.0.0'
        };
        this.context = context;
        this.options = $.extend(true, {}, defaults, (props || {}));
        this.updatePath = false;

        this.$multiform = $(this.context).find("#application-multiform-wrap");
        this.init();
    }
    init(){
        console.log('ApplicationsWizard loaded (' + this.options.version + ')', this.context);

        var that = this;

        let $methods = $("input[name='method']");

        $methods.on('change', function (e) {
            that.updatePath = true;
            that.onMethodChange(this);
        });
        $("input[name='subject']").on('change', function (e) {
            that.updatePath = true;
            that.onSubjectChange(this);
        });

        $("input[name='aid_type']").on('change', function (e) {
            that.updatePath = true;
            that.onTypeChange(this);
        }).filter(':checked').each(function () {
            that.onTypeChange(this);
            return false;
        });

        if($methods.length){
            if($methods.filter(':checked').length){

            }else if(window.location.hash){

                let paths = window.location.hash.substring(1).split('/');
                if(paths[0]){
                    $methods.filter('[value="'+paths[0]+'"]').click();
                    if(paths[1]){
                        $('input[name="subject"][value="'+paths[1]+'"]').click();
                        if(paths[2]){
                            $('input[name="aid_type"][value="'+paths[2]+'"]').click();
                            if(paths[3]){
                                that.selected_kind = paths[3];
                            }
                        }
                    }
                }


            }
        }
    }
    onMethodChange(input){
        $("#submit-step-2")
            .addClass('submit-step-active')
            .find('.submit-step-wrap').addClass('d-none')
            .filter('#method-' + input.value).removeClass('d-none')
        ;
        $("input[name='subject']:checked").prop( "checked", false ).change();
        this.updateHashPath();

    }
    onSubjectChange(input){
        if(!input.checked){
            $("#submit-step-3")
                .removeClass('submit-step-active')
                .find('.submit-step-wrap').addClass('d-none')
            ;
        }else{
            $("#submit-step-3")
                .addClass('submit-step-active')
                .find('#aid-type').removeClass('d-none')
            ;
            this.updateHashPath();
        }
        $("input[name='aid_type']:checked").prop( "checked", false ).change();
    }
    onTypeChange(input){
        if(!input.checked){
            $(this.context).find("#application-multiform-wrap").html('');
        }else{
            this.loadApplicationMultiForm(
                $("input[name='subject']:checked").val(),
                input.value
            );
            this.updateHashPath();
        }


    }
    onKindChange(input){
        if(!input.checked){
            $(input).closest('.submit-step').next().removeClass('submit-step-active');
        }else{
            $(input).closest('.submit-step').next().addClass('submit-step-active');
            this.updateHashPath();
        }
    }

    updateHashPath(){

        if(!this.updatePath) return;

        var parts = [];
        $("input[name='method']:checked").each(function () {
            parts.push(this.value);
            return false;
        })
        $("input[name='subject']:checked").each(function () {
            parts.push(this.value);
            return false;
        })
        $("input[name='aid_type']:checked").each(function () {
            parts.push(this.value);
            return false;
        })
        $("input[name='aid_kind']:checked").each(function () {
            parts.push(this.value);
            return false;
        })
        window.location.hash = parts.join('/');
        this.updatePath = false;
    }


    loadTemplateForm(subject){

        let formData = this.getMultiformBaseData();

        formData['application_type'] = $("input[name='subject']:checked").val() + '_' + $("input[name='aid_type']:checked").val();

        $(subject).attr('disabled', 'disabled');

        $.post($(subject).data('url'), {
            form_data: formData
        }).done(function (r) {
            let $modal = $(r);
            $('body').append($modal);
            $modal.modal('show').on('hidden.bs.modal', function (e) {
                $modal.remove();
            })
        }).fail(function (e) {
        }).always(function (e) {
            $(subject).attr('disabled', null);
        })
    }

    loadApplicationMultiForm(subject_type, aid_type) {
        let that = this;
        let $container = $(this.context);

        if(!that.$multiform.data('guid')){
            that.$multiform.data('guid', that.uuidv4());
        }


        var h = $container.find("#application-multiform-wrap").innerHeight();
        $container.find("#application-multiform-wrap")
            .html( '<div class="text-center p-3"><div class="spinner-border" role="status"> <span class="sr-only">Loading...</span></div></div>')
            .css('min-height', h)
        ;
        $.ajax($(this.context).data('baseurl') + '/load_multiform', {
            data:{
                subject: subject_type,
                aid_type: aid_type,
                guid: that.$multiform.data('guid'),
                active_item: that.$multiform.data('active-item')
            }
        }).done(function (r) {

            that.$multiform.html(r).css('min-height', 0);
            CmsSelect2.init(that.$multiform);
            UserCodeInput.init(that.$multiform);


            that.$multiform.find("button[data-add-subject]").on('click', function (e) {
                //load new card
                let card = new ApplicationsReceiverCard(that, null, subject_type, aid_type);
                card.openCard();
                card.loadContent();

            });

            that.$multiform.find('#receivers-accordion > .card').each(function () {
                let card = new ApplicationsReceiverCard(that, $(this), subject_type, aid_type);
                card.loadContent();
            })

            that.$multiform.find('#receivers-accordion > .card > .collapsable.show').each(function () {
                let $openCard = $(this).closest('.card');
                $openCard[0].scrollIntoView();

                setTimeout(function () {
                    $openCard[0].scrollIntoView();
                }, 100)



                return false;
            })


            let $aidKinds = that.$multiform.find("input[name='aid_kind']");

            $aidKinds.on('change', function (e) {
                that.updatePath = true;
                that.onKindChange(this);
            });
            that.$multiform.find('[data-baseform]').find('input,select').on('change', function () {
                that.updateAllReceiverFormsData();
            })

            that.$multiform.find('[data-multiform-action] button').on('click', function (e) {
                let button = e.currentTarget;
                if(button.name === 'action'){
                    switch (button.value) {
                        case 'validate-all':
                            that.validateAllReceiverForms();
                            break;
                        case 'submit-all':
                            that.submitAllReceiverForms();
                            break;
                        case 'draft-all':
                            that.draftAllReceiverForms();
                            break;
                        case 'save-as-template':
                            that.loadTemplateForm(this)
                            break;
                    }
                }
            })

            if($aidKinds.filter(":checked").length){
                that.onKindChange($aidKinds.filter(":checked")[0]);
            }else if(that.selected_kind){
                $("input[name='aid_kind'][value='"+that.selected_kind+"']").click();
            }
            that.selected_kind = null;

            that.checkMultiformActions();
        }).fail(function (e) {
            $container.find("#application-multiform-wrap").html('failed');
        })
    }
    addFormsToQueue(){
        this.cardsQueue = [];
        this.$multiform.find('#receivers-accordion > .card').each(function (index, card) {
            let cardInstance = $(card).data('instance');
            if(cardInstance.hasForm()){
                cardInstance.showProgress();
                this.cardsQueue.push(cardInstance);
            }
        }.bind(this))
    }

    submitAllReceiverForms(){
        this.addFormsToQueue();
        this.disableMultiformActions();
        this.checkSubmitQueue();
    }
    draftAllReceiverForms(){
        this.addFormsToQueue();
        this.disableMultiformActions();
        this.checkDraftQueue();
    }
    validateAllReceiverForms(){
        this.addFormsToQueue();
        this.disableMultiformActions();
        this.checkValidationQueue();
    }

    checkSubmitQueue(){
        if(this.cardsQueue && this.cardsQueue.length){
            let cardInstance = this.cardsQueue.shift();
            cardInstance.submitForm(this.checkSubmitQueue.bind(this));
        }else{
            this.enableMultiformActions();
        }
    }
    checkValidationQueue(){
        if(this.cardsQueue && this.cardsQueue.length){
            let cardInstance = this.cardsQueue.shift();
            cardInstance.validateForm(this.checkValidationQueue.bind(this));
        }else{
            this.enableMultiformActions();
        }
    }
    checkDraftQueue(){
        if(this.cardsQueue && this.cardsQueue.length){
            let cardInstance = this.cardsQueue.shift();
            cardInstance.draftForm(this.checkDraftQueue.bind(this));
        }else{
            this.enableMultiformActions();
        }
    }

    updateAllReceiverFormsData(){
        let that = this;
        that.$multiform.find('#receivers-accordion > .card').each(function () {
            $(this).data('instance').updateFormBaseData();
        })
    }
    disableMultiformActions(){
        this.$multiform.find('[data-multiform-action] button.multiform-action').attr('disabled', 'disabled');
    }
    enableMultiformActions(){
        this.$multiform.find('[data-multiform-action] button.multiform-action').attr('disabled', null);
    }
    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    getMultiformBaseData(){
        let data = {};
        this.$multiform.find('[data-baseform]').find('input[type="radio"]:checked,select').each(function (index,input) {
            if(input.value){
                if(!data[input.name]){
                    data[input.name] = [];
                }
                data[input.name].push(input.value);
            }
        });

        for (var k in data){
            if(data[k].length === 1){
                data[k] = data[k][0];
            }
        }

        return data;
    }

    invalidateLayout(){
        this.checkAddButtonsLayout();
        this.checkMultiformActions();
    }

    checkMultiformActions(){
        var hasAnyForm = false;
        this.$multiform.find('#receivers-accordion > .card').each(function () {
            let cardInstance = $(this).data('instance');



            if(cardInstance.hasForm()){
                hasAnyForm = true;
                return false;
            }
        });

        if(hasAnyForm){
            this.enableMultiformActions();
        }else{
            this.disableMultiformActions();
        }
    }
    checkAddButtonsLayout(){
        if(!this.$multiform) return;

        if(this.$multiform.find('#receivers-accordion > .card').length){
            this.$multiform.find("[data-add-subject-second-wrap]").removeClass('d-none');
        }else{
            this.$multiform.find("[data-add-subject-second-wrap]").addClass('d-none');
        }
    }
}

export default ApplicationsWizard;